import React, { Component, Fragment } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Button,
  Table,
} from "reactstrap";

import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as orderActions from './actions'
import * as common from '../../lib/common'
import ButtonExt from "../controls/ButtonExt"
import { BtnPermissions } from '../../lib/BtnPermissions'
import orderConstants, * as constants from "./constants"
import { storedb } from '../../views/client/storedb'
import OrderCustomerInfo from "./_OrderCustomerInfo"
import OrderHistory from "./_OrderHistory"
import AppConfig from '../../config/app'

var dbContext;
class MarketingOrderDetails extends Component {
  constructor(props) {
    super(props);
    dbContext = storedb();
    this._isMounted = false
    this.state = {
      donHangId: '',
      hasChanged: false,
      modalApprove: false,
      modalReturnItems: false,
      modalHistory: false,
      orderHistories: [],
      isShowMoreContent: true,
      showMoreClass: 'order-show-more',
      isReadyClick: true,
      showCkPercent: dbContext.getSettingValue(AppConfig.SETTINGKEYS.ShowCkPercent, "0")
    }
  }

  checkParamsOrder = (callback) => {
    const params = this.props.match ? this.props.match.params : {};
    if (params) {
      const mode = orderConstants.MODE.IN_VIEW
      const { id } = params;
      this.props.setOrderId(id)

      this.props.setMode(mode)

      this.setState({hasChanged: true}, () => {
        callback(mode, id)
      })
    }
  }
  setShowHide = () => {
    const { isShowMoreContent } = this.state
    if (isShowMoreContent) {
      this.setState({ showMoreClass: 'animated', isShowMoreContent: false })
    } else {
      this.setState({ showMoreClass: 'order-show-more', isShowMoreContent: true })
    }
  }
  addHoaDonClick = () => {
    this.props.history.push(`/marketing-order`)
  }
  editClick = () => {
    this.props.history.push(`/marketing-order-edit/${this.props.orderId}`);
  }
  sendClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn có muốn gửi đơn hàng <b className="text-danger">{item.ma_don_hang}</b> này không?<br />
              Các nhà thuốc trong đơn sẽ nhận được đơn của bạn sau khi gửi thành công.
            </p>
            <button className="text-danger" onClick={() => {
              const formData = {
                order_id: item.order_id,
                customer_ids: []
              }
              const onSuccess = ({code, message}) => {
                this.props.setIsLoading(false)
                if (code != 200) {
                  this.props.setError(message)
                } else {
                  dbContext.addAlert({key: item.order_id, text: message, type: "success"}, () => {
                    this.fetchData(null, item.order_id)
                  })
                }
              }
              this.props.setError("")
              this.props.setIsLoading(true)
              this.props.sendOrder(formData, onSuccess);
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    })
  }
  // in đơn hàng
  printOrderData = () => {
    const formData = {
      order_id: this.state.donHangId,
      store_id: dbContext.getStoreId()
    }
    this.props.loadOrderExport(formData);
  }
  // xem lich sư giao hàng 
  searchOrderHistoryData = (orderId, customerId, callback) => {
    const formData = {
      order_id: orderId,
      customer_id: customerId || '',
      page: 1,
      per_page: 20
    }
    this.props.loadOrderHistory(formData, callback);
  }
  historyClick = (order, customerId) => {
    this.searchOrderHistoryData(order.order_id, customerId, (data) => {
      this.setState({ modalHistory: true, orderHistories: data });
    });
  }
  // excel đơn hàng
  exportXls = (orderInfor) => {
    const formData = {
      orderId: orderInfor.order_id,
    }
    const dialogSaveFile = (data) => {
      var dataFile = new Blob([data], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "donhang.xlsx";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("Ten file", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    }
    this.props.loadOrderExcel(formData, dialogSaveFile)
  }
  printClick = (orderInfor) => {
    this.setState({ donHangId: orderInfor.order_id }, () => {
      this.printOrderData();
    })
  }
  closeDlgHistory = () => {
    this.setState({
      modalHistory: !this.state.modalHistory,
    });
  }

  // huỷ đơn hàng với những đơn chưa tiếp nhận xử lý
  cancelClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn có muốn huỷ đơn hàng <b className="text-danger">{item.ma_don_hang}</b> này không?<br />
              Việc này đồng nghĩa đơn hàng này sẽ đưa về trạng thái huỷ.
            </p>
            <button className="text-danger" onClick={() => {
              const formData = {
                store_id: item.store_id,
                order_id: item.order_id
              }
              const callOnSuccess = () => {
                this.setState({isReadyClick: false})
                setTimeout(this.return2List, 1500)
              }
              this.props.cancelOrder(formData, callOnSuccess)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }

  // huỷ bỏ lock đơn hàng, danh cho trường hợp đang mở chỉnh sửa mà quên chưa lưu lại
  unlockOrderClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Huỷ quá trình cập nhật đơn hàng <b className="text-danger">{item.ma_don_hang}</b> này?
          </p>
            <button className="text-danger" onClick={() => {
              const payload = {
                orderId: this.props.orderId,
                typeOfOrder: this.props.typeOfOrder
              }
              this.props.unlockOrder(payload, () => {
                setTimeout(this.fetchData, 1500)
              })
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }

  return2List = () => {
    this.props.history.push(`/marketing-orders`);
  }
  fetchData = (mode, orderId) => {
    const payload = {
      orderId: orderId || this.props.orderId,
      mode: mode || this.props.mode
    }
    this.setState({isReadyClick: true})
    this.props.getOrderDetails(payload)
  }
  componentDidMount() {
    this._isMounted = true
    // fetch data
    this.checkParamsOrder((mode, orderId) => {
      if (this._isMounted) {
        this.fetchData(mode, orderId)
      }
    })
  }

  componentWillUnmount() {
    this._isMounted = false
    // reset callback func
    this.props.setCallbackFunc(() => { })
  }
  render() {
    const sumQuantity = () => {
      const items = this.props.orderInfor.items || [];
      return common.sum(items, "so_luong").toLocaleString()
    }
    const sumRefun = (isShowSumValue) => {
      if (!isShowSumValue) {
        return ""
      }
      const items = this.props.orderInfor.items || [];
      return common.sum(items, "chiet_khau").toLocaleString()
    }
    const sumFee = () => {
      const items = this.props.orderInfor.items || [];
      return common.sum(items, "thanh_tien").toLocaleString()
    }

    const getItems = (items) => {
      items = items || [];
      return items.map((item, idx) => {
        return [
          (
            <tr className="hide-in-mobile" key={idx}>
              <td scope="col" className="text-justify">
                {`${item.sku}/ ${item.ten_hang}`}
              </td>
              <td scope="col" className="text-justify">
                {item.dvt}
              </td>
              <td scope="col" className="text-right">
                {item.so_luong.toLocaleString()}
              </td>
              <td scope="col" className="text-right">
                {item.gia_ban.toLocaleString()}
              </td>
              <td scope="col" className="text-right">
                {item.chiet_khau ? item.chiet_khau.toLocaleString() : ''}
              </td>
              <td scope="col" className="text-right">
                {item.thanh_tien.toLocaleString()}
              </td>
            </tr>
          ),
          (
            <tr className="show-in-mobile" key={`${idx}-0`}>
              <td scope="col" colSpan="5" className="text-justify">
                {`${item.sku}/ ${item.ten_hang}`}
              </td>
            </tr>
          ),
          (
            <tr className="show-in-mobile" key={`${idx}-1`}>
              <td scope="col" className="text-justify border-bottom">
                {item.dvt}
              </td>
              <td scope="col" className="text-right border-bottom">
                {item.so_luong.toLocaleString()}
              </td>
              <td scope="col" className="text-right border-bottom">
                {item.gia_ban.toLocaleString()}
              </td>
              <td scope="col" className="text-right border-bottom">
                {item.chiet_khau ? item.chiet_khau.toLocaleString() : ''}
              </td>
              <td scope="col" className="text-right border-bottom">
                {item.thanh_tien.toLocaleString()}
              </td>
            </tr>
          ),
      ]
      });
    }

    const {
      requesting,
      orderInfor,
      errors,
      messages,
    } = this.props
    const {
      showMoreClass,
      isShowMoreContent,
      isReadyClick,
      showCkPercent,
    } = this.state
    const { 
      items 
    } = orderInfor
    const isShowCKPercent = showCkPercent === "1"
    const isEditable = orderInfor && orderInfor.is_editable
    const isLocking = orderInfor && orderInfor.is_locking
    let msgLocking = ''
    if (isLocking) {
      const userId = dbContext.info.Id
      const lockById = orderInfor ? orderInfor.lock_by_id : 0
      if (lockById === userId) {
        msgLocking = `Đơn đang được sửa bởi (${orderInfor.lock_by}) ở thời điểm trước đó. Bấm [Huỷ] để thao tác lại.`
      } else {
        msgLocking = `Đơn đang được sửa bởi ${orderInfor.lock_by}`
      }
    }
    return (
      <div className="animated fadeIn order">
        <BlockUi tag="div" blocking={requesting}>
          <div className="col-sm-7 col-md-8 pull-left order-view">
            <Card>
              <CardBody className="p-1">
                <div className="col-sm-12">
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Mã đơn hàng: <b>{orderInfor.ma_don_hang}</b></span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Trạng thái: {common.getOrderMarketingStatusText(orderInfor.trang_thai, true)}</span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Nhân viên: <b>{orderInfor.ten_nhan_vien}</b></span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Ngày lập: <b>{common.formatDateTime(orderInfor.ngay_lap, "HH:mm DD/MM/YYYY")}</b></span>
                  </div>
                  <div className={`col-sm-6 pull-left view-row mb-2 ${showMoreClass}`}>
                    <span>Xuất hóa đơn: <b>{orderInfor.xuat_hoa_don ? 'Có' : 'Không'}</b></span>
                  </div>
                  <div className={`col-sm-6 pull-left view-row mb-2 ${showMoreClass}`}>
                    <span>Ghi chú: <b>{orderInfor.ghi_chu}</b></span>
                  </div>
                </div>
                <OrderCustomerInfo
                  className="show-in-mobile"
                  typeOfOrder={this.props.typeOfOrder}
                  orderInfor={orderInfor}
                  isLocking={isLocking}
                  msgLocking={msgLocking}
                  isEditable={isEditable}
                  showMoreClass={showMoreClass}
                  isShowMoreContent={isShowMoreContent}
                  unlockOrder={this.unlockOrderClick}
                  setShowHide={this.setShowHide}
                />
                <div className="clearfix"></div>
                <div className="col-sm-12 mb-2">
                  <Table hover responsive className="table-outline table-sm mb-0">
                    <thead className="thead-default">
                      <tr className="hide-in-mobile">
                        <th scope="col" className="text-justify">
                          Tên thuốc
                        </th>
                        <th scope="col" className="text-justify">
                          ĐVT
                        </th>
                        <th scope="col" className="text-right">
                          Số lượng
                        </th>
                        <th scope="col" className="text-right">
                          Đơn gía
                        </th>
                        <th scope="col" className="text-right">
                          C/khấu {isShowCKPercent ? "(%)" : ""}
                        </th>
                        <th scope="col" className="text-right">
                          Thành tiền
                        </th>
                      </tr>
                      <tr className="show-in-mobile">
                        <th scope="col" colSpan="5" className="text-justify border-bottom">
                          Tên
                        </th>
                      </tr>
                      <tr className="show-in-mobile">
                        <th scope="col" className="text-justify">
                          ĐVT
                        </th>
                        <th scope="col" className="text-right">
                          S/lượng
                        </th>
                        <th scope="col" className="text-right">
                          Đ/gía
                        </th>
                        <th scope="col" className="text-right">
                          C/khấu {isShowCKPercent ? "(%)" : ""}
                        </th>
                        <th scope="col" className="text-right">
                          T/tiền
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {getItems(items)}
                    </tbody>
                    <tfoot className="thead-default">
                      <tr className="hide-in-mobile">
                        <td colSpan="1" scope="col" className="text-right">
                          <span className="text-primary font-weight-bold">Tổng<label className="d-none"> cộng</label>: </span>
                        </td>
                        <td colSpan="2" scope="col" className="text-right font-weight-bold">
                          {sumQuantity()}
                        </td>
                        <td scope="col" colSpan="2" className="text-right font-weight-bold">
                          {sumRefun(!isShowCKPercent)}
                        </td>
                        <td scope="col" className="text-right font-weight-bold">
                          {sumFee()}
                        </td>
                      </tr>
                      <tr className="show-in-mobile">
                        <td colSpan="1" scope="col" className="text-right">
                          <span className="text-primary font-weight-bold">Tổng<label className="d-none"> cộng</label>: </span>
                        </td>
                        <td colSpan="1" scope="col" className="text-right font-weight-bold">
                          {sumQuantity()}
                        </td>
                        <td scope="col" colSpan="2" className="text-right font-weight-bold">
                          {sumRefun(!isShowCKPercent)}
                        </td>
                        <td scope="col" className="text-right font-weight-bold">
                          {sumFee()}
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
              </CardBody>
              {!requesting && isReadyClick && (
                <CardFooter className="pr-1 pl-1">
                  <div>
                    <div className="col-sm-12">
                      {!!errors.length && (
                        <Errors message="Failure to signup due to:" errors={errors} />
                      )}
                      {!!messages.length && (
                        <Messages messages={messages} />
                      )}
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div role="group">
                        <Button className="btn btn-secondary mr-1 mb-1" onClick={() => this.return2List()}>
                          <i className="fa fa-history"></i> Quay về
                        </Button>
                        {orderInfor.c_edt && (
                          <ButtonExt size="md" btnClass="btn btn-warning mr-1" btnClick={() => this.editClick(orderInfor)}
                            iconClass="fa-pencil" displayText="Sửa"
                            permission={BtnPermissions.DonHang.SAVE_ORDER} />
                        )}
                        {orderInfor.c_prc && (
                          <ButtonExt size="md" btnClass="btn btn-green mr-1" btnClick={() => this.sendClick(orderInfor)}
                            iconClass="fa-paper-plane" displayText="Gửi"
                            permission={BtnPermissions.DonHang.SAVE_ORDER} />
                        )}
                        {orderInfor.c_ccl && (
                          <ButtonExt size="md" btnClass="btn btn-danger mr-1" btnClick={() => this.cancelClick(orderInfor)}
                                     iconClass="fa-remove" displayText={"Huỷ"}
                                     permission={BtnPermissions.DonHang.CANCEL_ORDER} />
                        )}
                        <ButtonExt size="md" btnClass="btn btn-info mr-1" btnClick={() => this.historyClick(orderInfor)}
                            iconClass="fa-clock-o" displayText="Ls đ/hàng"
                            permission={""} />
                        <ButtonExt size="md" btnClass="btn btn-primary mr-1" btnClick={this.addHoaDonClick}
                          iconClass="fa-plus" displayText="Thêm đơn"
                          permission={BtnPermissions.DonHang.SAVE_ORDER} />
                      </div>
                  </div>
                </CardFooter>
              )}
            </Card>
          </div>
          <div className="col-sm-5 col-md-4 pull-left order-view hide-in-mobile">
            <Card>
              <CardBody className="p-1">
                <OrderCustomerInfo
                  typeOfOrder={this.props.typeOfOrder}
                  orderInfor={orderInfor}
                  isLocking={isLocking}
                  msgLocking={msgLocking}
                  isEditable={isEditable}
                  unlockOrder={this.unlockOrderClick}
                  onCustomerClick={(customerId) => this.historyClick(orderInfor, customerId)}
                />
              </CardBody>
            </Card>
          </div>
          <OrderHistory
            isOpen={this.state.modalHistory}
            onClose={this.closeDlgHistory}
            orderHistory={this.state.orderHistories}
          />
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  customerInfor: state.marketingOrder.customerInfor,
  orderInfor: state.marketingOrder.orderInfor,
  errors: state.marketingOrder.errors,
  messages: state.marketingOrder.messages,
  warnings: state.marketingOrder.warnings,
  requesting: state.marketingOrder.requesting,
  typeOfOrder: state.marketingOrder.typeOfOrder,
  orderId: state.marketingOrder.orderId,
  orderHistory: state.marketingOrder.orderHistory,
})

const connected = connect(mapStateToProps,
  {
    setIsLoading: orderActions.setIsLoading,
    setError: orderActions.setError,
    setMessage: orderActions.setMessage,
    setOrderId: orderActions.setOrderId,
    setMode: orderActions.setMode,
    setOrderInfor: orderActions.setOrderInfor,
    getOrderDetails: orderActions.getOrderDetails,
    cancelOrder: orderActions.cancelOrder,
    unlockOrder: orderActions.unlockOrder,
    sendOrder: orderActions.sendOrder,
    setCallbackFunc: orderActions.setCallbackFunc,
    loadOrderHistory: orderActions.loadOrderHistory,
    loadOrderExport: orderActions.loadOrderExport,
    loadOrderExcel: orderActions.loadOrderExcel,
    SetOrderConfirmMoney: orderActions.SetOrderConfirmMoney
  })(MarketingOrderDetails)

const formed = reduxForm({
  form: 'marketingOrder',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/MarketingOrder/MarketingOrderDetails.js